import { render, staticRenderFns } from "./vDocumentsWithParts.vue?vue&type=template&id=754454ec"
import script from "./vDocumentsWithParts.vue?vue&type=script&lang=js"
export * from "./vDocumentsWithParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports